import Skeleton from 'react-loading-skeleton'
import { SKELETON_BASE_COLOR } from '../../constants'

export const SingleEmptyHomeCard = () => {
  return (
    <div className="flex flex-col">
      <Skeleton
        width={'100%'}
        height={'100%'}
        baseColor={SKELETON_BASE_COLOR}
        highlightColor={SKELETON_BASE_COLOR}
        className="!rounded-xl aspect-square"
      />

      <Skeleton
        width={'100%'}
        height={30}
        baseColor={SKELETON_BASE_COLOR}
        highlightColor={SKELETON_BASE_COLOR}
        className="!rounded-xl mt-4"
      />

      <Skeleton
        width={'100%'}
        height={10}
        baseColor={SKELETON_BASE_COLOR}
        highlightColor={SKELETON_BASE_COLOR}
        className="!rounded-x mt-1"
      />
    </div>
  )
}
